import { render, staticRenderFns } from "./CreateEditTagModal.vue?vue&type=template&id=185a3f64&"
import script from "./CreateEditTagModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditTagModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('185a3f64')) {
      api.createRecord('185a3f64', component.options)
    } else {
      api.reload('185a3f64', component.options)
    }
    module.hot.accept("./CreateEditTagModal.vue?vue&type=template&id=185a3f64&", function () {
      api.rerender('185a3f64', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/Tags/CreateEditTagModal.vue"
export default component.exports